import type Dinero from 'dinero.js';
import { defineStore } from 'pinia';
import type { AppConfig } from '@/types';
import API from '@/api';
import { setCashierPath } from '@/state/appState';

let loadConfigPromise: Promise<void> | null = null;

/**
 * Replaces Spark's server-injected `window.Spark` global. Loaded once per session
 * before the first authenticated route resolves.
 */
export const useAppConfigStore = defineStore('appConfig', {
    state: (): { config: AppConfig | null } => ({
        config: null,
    }),
    getters: {
        appConfig: state => state.config,
        usesTeams: (state): boolean => state.config?.usesTeams === true,
        usesApi: (state): boolean => state.config?.usesApi === true,
        currency: (state): Dinero.Currency => state.config?.currency ?? 'USD',
        currencyLocale: (state): string => state.config?.currencyLocale ?? 'en',
    },
    actions: {
        async loadConfig(): Promise<void> {
            if (this.config != null) return;
            if (loadConfigPromise != null) return loadConfigPromise;

            loadConfigPromise = API.bootstrap.fetchConfig()
                .then((config) => {
                    this.config = config;
                    setCashierPath(config.cashierPath);
                })
                .finally(() => {
                    loadConfigPromise = null;
                });

            return loadConfigPromise;
        },
    },
});
